function isEmptyOrSpaces(str){
    return str === null || str.match(/^ *$/) !== null;
}
//for scroll logo Title and subtitle alignment
const subtitle = document.querySelector('.main-logo-svg__subtitle')
if (!isEmptyOrSpaces(subtitle.innerHTML)) {

    const title = document.querySelector('.main-logo-svg__title');

    var md = window.matchMedia("(max-width: 991px)")
    var sm = window.matchMedia("(max-width: 575.98px)")
    var xs = window.matchMedia("(max-width: 330px)")


    // return
    if (sm.matches && !xs.matches) {
        title.style.transform = "translateY(-2px)";
        subtitle.style.transform = "translateY(-1px)";
    }
    else if (sm.matches && xs.matches) {
        title.style.transform = "translateY(2px)";
        subtitle.style.transform = "translateY(6px)";
    }
    else {
        title.style.transform = "translateY(-8px)";
        subtitle.style.transform = "translateY(-7px)";
    }

}
